export default __webpack_public_path__ + "static/media/home-bg.7b5b7987.png";